import { render, staticRenderFns } from "./stream-name.vue?vue&type=template&id=3bbce8ee"
import script from "./stream-name.vue?vue&type=script&lang=js"
export * from "./stream-name.vue?vue&type=script&lang=js"
import style0 from "./stream-name.vue?vue&type=style&index=0&id=3bbce8ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports